import { getDependentAge } from "enrollment/features/Shared/FamilySelect/utils";
import { displayDependentAvatar } from "enrollment/features/Family/FamilyDetailsPage/components";

interface ProfileWidgetProps {
  firstName: string;
  birthdate?: string;
  profile: any;
};

export const ProfileWidget = ({
  firstName,
  birthdate,
  profile,
}: ProfileWidgetProps) => {
  return (
    <div className="d-flex flex-row align-items-end">
      <div className="pr-1">
        {displayDependentAvatar(profile, 24)}
      </div>
      <p className="mb-0">{`${firstName}${ birthdate ? ` (${getDependentAge(birthdate)})` : ''}`}</p>
    </div>
  );
};